import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save, Edit3 } from "lucide-react";
import { AdminField, ImageUploadField, AdminModal } from "@/pages/admin/AdminBits";
import RichTextEditor from "@/components/common/RichTextEditor";

export default function AdminActivityAreas() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [f, setF] = useState({});

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/activity-areas?_=${Date.now()}`);
      setItems(data);
    } catch { toast.error("Yüklenemedi"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const startEdit = (a) => { setEditing(a); setF({ ...a }); };
  const close = () => { setEditing(null); setF({}); };
  const onChange = (e) => setF({ ...f, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/activity-areas/${editing.slug}`, {
        title: f.title || "",
        description: f.description || "",
        content_html: f.content_html || "",
        image: f.image || "",
        button_label: f.button_label || "İletişim",
        order: Number(f.order) || 0,
      });
      toast.success("Kaydedildi");
      close();
      load();
    } catch { toast.error("Kaydedilemedi"); }
  };

  return (
    <div data-testid="admin-activity-areas">
      <div className="mb-6">
        <h1 className="font-heading text-2xl font-bold text-[#102A43]">Faaliyet Alanları</h1>
        <p className="text-sm text-[#4B5563] mt-1">6 faaliyet alanının başlığını, açıklamasını, içerik metnini, görselini ve buton etiketini (örn. iletişim e-postası) yönetin.</p>
      </div>

      {loading ? (
        <div className="py-16 text-center text-[#4B5563]">Yükleniyor…</div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map(a => (
            <div key={a.slug} className="rounded-2xl border border-[#E5E7EB] bg-white overflow-hidden" data-testid={`area-card-${a.slug}`}>
              <div className="aspect-video bg-[#F7F9FA] overflow-hidden">
                {a.image ? <img src={a.image} alt="" className="w-full h-full object-cover"/> : <div className="w-full h-full flex items-center justify-center text-[#4B5563] text-xs">Görsel yok</div>}
              </div>
              <div className="p-4">
                <h3 className="font-heading font-bold text-[#102A43] text-sm">{a.title || a.slug}</h3>
                <p className="text-xs text-[#4B5563] mt-1 line-clamp-2">{a.description || "Açıklama girilmemiş"}</p>
                <div className="text-[10px] text-[#4B5563] mt-2 uppercase tracking-widest">Buton: {a.button_label || "—"}</div>
                <button onClick={() => startEdit(a)} className="btn-outline mt-3 w-full justify-center text-xs" data-testid={`edit-${a.slug}`}>
                  <Edit3 className="w-3.5 h-3.5"/> Düzenle
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <AdminModal open={!!editing} onClose={close} title={editing ? `Düzenle: ${editing.title || editing.slug}` : ""} testid="area-modal">
        <form onSubmit={submit} className="space-y-4" data-testid="area-form">
          <AdminField label="Başlık" name="title" value={f.title} onChange={onChange} testid="area-input-title"/>
          <AdminField label="Kısa Açıklama (Hero altında görünür)" name="description" value={f.description} onChange={onChange} isTextArea rows={3} testid="area-input-desc"/>
          <ImageUploadField label="Görsel" value={f.image} onChange={(url) => setF({ ...f, image: url })} testid="area-input-image"/>
          <div>
            <label className="block text-xs font-medium text-[#4B5563] mb-1 uppercase tracking-wider">İçerik (Zengin Metin)</label>
            <RichTextEditor value={f.content_html} onChange={(v) => setF({ ...f, content_html: v })} testid="area-input-content"/>
            <p className="text-xs text-[#4B5563] mt-1">Boş bırakırsanız varsayılan bilgi metni kullanılır.</p>
          </div>
          <AdminField label="Altın Buton Etiketi (Tıklanamaz — örn: iletisim@useko.org)" name="button_label" value={f.button_label} onChange={onChange} testid="area-input-btn"/>
          <div className="flex justify-end gap-2 pt-3 border-t border-[#E5E7EB]">
            <button type="button" onClick={close} className="btn-outline" data-testid="area-cancel">İptal</button>
            <button type="submit" className="btn-primary" data-testid="area-save"><Save className="w-4 h-4"/> Kaydet</button>
          </div>
        </form>
      </AdminModal>
    </div>
  );
}
